<ng-container *ngIf="loading; else notificationsTemplate">
  <crm-spinner top="mt-3"></crm-spinner>
</ng-container>
<ng-template #notificationsTemplate>
  <div class="lk-eu-informer-favorites__link-row">
    <a
      class="lk-eu-informer-favorites__link"
      (click)="closeSidebar.emit()"
      routerLink="/lk/external-user/hd/list"
      [queryParams]="
        {
          onlyFavorites: true,
          finishDate: false
        } | concatDateParams: 'year'
      ">
      <i class="pi pi-window-maximize"></i>
      Подробнее
    </a>
  </div>

  <div
    *ngIf="tasks?.length; else notData"
    class="lk-eu-informer-favorites__list"
    (scroll)="onScrollEnd($any($event.target))">
    <div
      *ngFor="let task of tasks; first as isFirst"
      class="{{ isFirst ? 'pb-3' : 'py-3' }} mr-3">
      <ng-template
        [ngTemplateOutlet]="cardNotificationTask"
        [ngTemplateOutletContext]="{ task: task }"></ng-template>
    </div>
    <div
      *ngIf="paginationLoading"
      class="text-center">
      <p-progressSpinner
        [style]="{
          width: '50px',
          height: '50px'
        }"></p-progressSpinner>
    </div>
  </div>

  <ng-template #notData>
    <crm-no-data [size]="NoDataSize"></crm-no-data>
    <h4 class="font-normal text-center">Нет избранных</h4>
  </ng-template>

  <ng-template
    #cardNotificationTask
    let-task="task">
    <ng-container *ngIf="toTask(task) as task">
      <a
        routerLink="/lk/external-user/hd/card/{{ hdPrefixService.getPrefixedNumber(task) }}"
        (click)="closeSidebar.emit()">
        <p-card styleClass="very-compact-card">
          <div class="px-5 py-3">
            <div class="flex justify-content-between align-items-center gap-2">
              <div>
                <p
                  style="font-size: 1.2rem"
                  class="font-bold frm-color-blue">
                  Заявка {{ hdPrefixService.getPrefixedNumber(task) }}
                </p>
                <div class="text-sm text-400">{{ task.created | date: 'dd.MM.yyyy' }}</div>
              </div>

              <crm-status-label
                [name]="task.status.name"
                [color]="task.status.color"></crm-status-label>
            </div>

            <p-divider styleClass="my-3"></p-divider>
            <div class="flex justify-content-between gap-3">
              <p class="text-color-secondary font-medium">Описание</p>
              <div
                *ngIf="task.description?.length; else notDescription"
                [innerHtml]="task.description | truncate: 150:true | safeHtml"></div>

              <ng-template #notDescription>
                <p class="font-medium">Отсутствует</p>
              </ng-template>
            </div>

            <p-divider styleClass="my-3"></p-divider>
            <div class="flex justify-content-between gap-3">
              <p class="text-color-secondary font-medium">Тип</p>
              <div *ngIf="task.taskType; else notTaskType">{{ task.taskType.name | truncate: 30 }}</div>
              <ng-template #notTaskType>
                <p class="font-medium">Отсутствует</p>
              </ng-template>
            </div>
          </div>
        </p-card>
      </a>
    </ng-container>
  </ng-template>
</ng-template>
